module.exports = __webpack_public_path__ + "static/media/new2-mob@2x.6aba5efa.png";